import React from 'react';
import CustomerContainer from '@src/containers/Customer';
import PermissionGate from '@src/components/PermissionGate';
import { PERMISSIONS } from '@src/constants';

const Customer = () => (
  <PermissionGate
    requiredPermissions={[
      PERMISSIONS.VIEW_CUSTOMER,
      PERMISSIONS.MANAGE_CUSTOMER,
    ]}
  >
    <CustomerContainer />
  </PermissionGate>
);

export default Customer;
